import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { GET_ACCACCOUNT, DELETE_ACCACCOUNT, UPDATE_ACCACCOUNT, ADD_NEW_ACCACCOUNT, GET_ACCACCOUNT_ONE } from "./actionType";

import { getAccAccountSuccess, getAccAccountFail, deleteAccAccountSuccess, deleteAccAccountFail, updateAccAccountSuccess, updateAccAccountFail, addAccAccountSuccess, addAccAccountFail } from "./action";

//Include Both Helper File with needed methods
import { approveAccAccountApi, getAccAccountApi, updateAccAccountApi, deleteAccAccountApi, addNewAccAccountApi, getOneAccAccountApi } from "../../helpers/backend_helper";

function* getAccAccount({ payload: accAccount }) {
  try {
    const response = yield call(getAccAccountApi, accAccount);
    yield put(getAccAccountSuccess(GET_ACCACCOUNT, response.data));
  } catch (error) {
    yield put(getAccAccountFail(GET_ACCACCOUNT, error));
  }
}

function* getAccAcountOne({ payload: id }) {
  try {
    const response = yield call(getOneAccAccountApi, id);
    yield put(getAccAccountSuccess(GET_ACCACCOUNT_ONE, response.data));
  } catch (error) {
    yield put(getAccAccountFail(GET_ACCACCOUNT_ONE, error));
  }
}

function* onUpdateAccAccount({ payload: accAccount }) {
  try {
    if (accAccount.setApprove) {
      const response = yield call(approveAccAccountApi, accAccount);
      yield put(updateAccAccountSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    } else {
      const response = yield call(updateAccAccountApi, accAccount);
      yield put(updateAccAccountSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updateAccAccountFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteAccAccount({ payload: accAccount }) {
  try {
    const response = yield call(deleteAccAccountApi, accAccount);
    yield put(deleteAccAccountSuccess({ accAccount, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteAccAccountFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewAccAccount({ payload: accAccount }) {
  try {
    const response = yield call(addNewAccAccountApi, accAccount);
    yield put(addAccAccountSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addAccAccountFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

export function* watchGetAccAccount() {
  yield takeEvery(GET_ACCACCOUNT, getAccAccount);
}

export function* watchGetAccAccountOne() {
  yield takeEvery(GET_ACCACCOUNT_ONE, getAccAcountOne);
}

export function* watchUpdateAccAccount() {
  yield takeEvery(UPDATE_ACCACCOUNT, onUpdateAccAccount);
}

export function* watchDeleteAccAccount() {
  yield takeEvery(DELETE_ACCACCOUNT, onDeleteAccAccount);
}

export function* watchAddNewAccAccount() {
  yield takeEvery(ADD_NEW_ACCACCOUNT, onAddNewAccAccount);
}

function* accAccountSaga() {
  yield all([fork(watchGetAccAccount), fork(watchGetAccAccountOne), fork(watchDeleteAccAccount), fork(watchUpdateAccAccount), fork(watchAddNewAccAccount)]);
}

export default accAccountSaga;
